/**
 * 菜单图标
 */
const routerMap = {
  home: {
    historyIcon: 'http://img.yimutian.com/crm/5cb7ea726ef1434e6e4eb4669988fad1.png',
    icon: 'http://img.yimutian.com/misc/5d11ded0885b9303cb178400841d19f2.png',
    selectedIcon: 'http://img.yimutian.com/misc/5d11f9d57960423e11177be93a41cf41.png'
  },
  supplyList: {
    historyIcon: 'http://img.yimutian.com/crm/5baf015464008157d936f9ef0f07dbf1.png',
    icon: 'http://img.yimutian.com/misc/5d11df827960423e11176a35134d555c.png',
    selectedIcon: 'http://img.yimutian.com/misc/5d11df6e885b9303cb1784569c8607e9.png'
  },
  orderManager: {
    historyIcon: 'http://img.yimutian.com/crm/5baf010164008157d936f9b0e9c25667.png',
    icon: 'http://img.yimutian.com/crm/5c19e2f96400816b261ae237a813bf46.png',
    selectedIcon: 'http://img.yimutian.com/crm/5c19e2f96ef1434e6e0017158db79f0c.png'

  },
  orderList: {
    historyIcon: 'http://img.yimutian.com/crm/5baf017a64008157d936fa03dcd6e2a9.png',
    icon: 'http://img.yimutian.com/misc/5d11dfd47960423e11176a7d02ca3560.png',
    selectedIcon: 'http://img.yimutian.com/misc/5d11e66d7960423e11176ec3f5389dc5.png'
  },
  batch_delivery: {
    historyIcon: 'http://img.yimutian.com/crm/5baf017a64008157d936fa03dcd6e2a9.png',
    icon: 'http://img.yimutian.com/crm/5baf24c16ef1433be538c8316fa8511f.png',
    selectedIcon: 'http://img.yimutian.com/crm/5baf24c56ef1433be538c8333b7628da.png'
  },
  chat: {
    icon: 'http://img.yimutian.com/misc/5d11e00e7960423e11176aa0e8c0a010.png',
    selectedIcon: 'http://img.yimutian.com/misc/5d11e646885b9303cb17893036c5d9be.png'
  },
  videoManagement: {
    icon: 'https://img.yimutian.com/crm/67088bdfb8277306f613583500280028.png',
    selectedIcon: 'https://img.yimutian.com/crm/67088c302d211f772313436200280028.png'
  }
}

export default function(name, attribute) {
  if (!name || !attribute) return ''
  try {
    return routerMap[name][attribute]
  } catch (e) {
    if (attribute === 'historyIcon') {
      return 'http://img.yimutian.com/crm/5cb7ea726ef1434e6e4eb4669988fad1.png'
    } else if (attribute === 'icon') {
      return 'http://img.yimutian.com/crm/5cb7e62a6400816b26793a06d794a164.png'
    } else if (attribute === 'selectedIcon') {
      return 'http://img.yimutian.com/crm/5cb7e62a6400816b26793a0763f198b4.png'
    }
    return ''
  }
}
